import api from '.';

export interface Fact {
  expiresAt: string;
  id: string;
  metricKey: string;
  source: string;
}

export enum EligibilityStatus {
  Eligible = 'eligible',
  Ineligible = 'ineligible',
}
export interface Eligibility {
  careCircleID: string;
  confidence: number;
  eligibilityStatus: EligibilityStatus;
  fundingType: string;
  id: string;
  relevantFacts: Fact[];
  updatedAt: string;
}

export const assessmentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEligibilities: builder.query<Eligibility[], string>({
      query: (careCircleID: string) => ({
        url: `/assessment/eligibility/${careCircleID}`,
      }),
      providesTags: ['Eligibilities'],
    }),
  }),
});
export const { useGetEligibilitiesQuery } = assessmentApi;

export default assessmentApi;
